import React, { FC } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ISurveyStatistics } from '../../shared/interfaces/ISurveyStatistics';
import useChartData from '../../hooks/useCalculateChartData';
import { Typography } from '@mui/material';

interface IRechartData {
  statistics: ISurveyStatistics;
  type: string;
  mode: string;
}

const ChartYearComponent: FC<IRechartData> = ({ statistics, type, mode }) => {
  let chartData = useChartData(statistics, type, mode);
  if (chartData.length > 12) {
    chartData = chartData.slice(-12);
  }

  const renderCustomizedLabel = (props: any) => {
    const { x, y, width, index } = props;
    const radius = 10;
    const count = chartData[index].surveys;

    return (
      <Typography
        component={'text'}
        x={x + width / 2}
        y={y - radius}
        fill="#000000"
        textAnchor="middle"
        dominantBaseline="middle"
        sx={{ fontWeight: 'bold' }}
      >
        {count}
      </Typography>
    );
  };

  let positiveLabel = 'positive';
  let negativeLabel = 'negative';
  let neutralLabel = 'neutral';
  if (type === 'CUSTOMSURVEY') {
    positiveLabel = 'beendet';
    negativeLabel = 'abgebrochen';
  }

  let showNeutral = type !== 'STANDARD' && type !== 'CUSTOMSURVEY';

  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
    >
      <BarChart
        width={500}
        data={chartData.map((data) => ({
          name: data.name,
          positive: data.positive,
          neutral: data.neutral,
          negative: data.negative,
        }))}
        barSize={40}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 20,
        }}
      >
        <XAxis
          dataKey="name"
          scale="point"
          padding={{ left: 80, right: 80 }}
        />
        <YAxis />
        <Tooltip />
        <Legend />
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
        />
        <Bar
          dataKey="positive"
          name={positiveLabel}
          stackId="a"
          background={{ fill: 'rgba(238,238,238,0.3)' }}
          fill="#74da67"
        >
          <LabelList
            dataKey="positive"
            name={positiveLabel}
            position="inside"
            fill="#000000"
            fontSize={13}
          />
        </Bar>
        {showNeutral && (
          <Bar
            dataKey="neutral"
            name={neutralLabel}
            stackId="a"
            background={{ fill: 'rgba(238,238,238,0.3)' }}
            fill="#F7B419"
          >
            <LabelList
              dataKey="neutral"
              name={neutralLabel}
              position="inside"
              fill="#000000"
              fontSize={13}
            />
          </Bar>
        )}
        <Bar
          dataKey="negative"
          name={negativeLabel}
          stackId="a"
          background={{ fill: 'rgba(238,238,238,0.3)' }}
          fill="#E15E5EFF"
          radius={[5, 5, 0, 0]}
        >
          <LabelList
            dataKey="negative"
            name={negativeLabel}
            position="inside"
            fill="#000000"
            fontSize={13}
          />
          <LabelList
            content={renderCustomizedLabel}
            fill="#ff0000"
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ChartYearComponent;
